// extracted by mini-css-extract-plugin
module.exports = {"root":"Chart_root__3qhz2","buttons":"Chart_buttons__3EDYJ"};